import React from 'react'

import axios from 'axios'

import PropTypes from 'prop-types'

import SimpleTable from '../../../shared/SimpleTable/SimpleTable'

class Events extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      events: [],
      model: "Event",
      headers: ["name","description","starts_at","ends_at"],
      openPopUp: false,
      title: "Events",

    }
    this.loadWorkflow = this.loadWorkflow.bind(this)

  }
  componentDidMount() {
    this.loadWorkflow(process.env.REACT_APP_API_DOMAIN + '/v1/clients/' + this.props.uid + '/events')
  }

  loadWorkflow(url) {
    axios({
      method: 'get',
      url: url,
      headers: { 'X-APP-API-KEY': localStorage.getItem('api_key') }
    }).then(resp => {
        this.setState({ events: resp.data })
        this.setState({ load: true })
    }).catch(error => console.log(error.response))
  }

  render() {
    return (
      <div>{
        this.state.load ? (
          <div>
            <SimpleTable
              removeButtonAdd={this.props.addButtonNone}
              removeLabel={true}
              items={this.state.events}
              model={this.state.model}
              headers={this.state.headers}
            />

          </div>
        ) : (null)
      }</div>
    )
  }
}
export default Events
Events.propTypes = {
  uid: PropTypes.string,
  addButtonNone: PropTypes.bool,
}
